var React = require('react');

function HundredOneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M127.7 381V93.9L38.05 148.9L0.650004 89.5L139.8 0.949976H211.85V381H127.7Z","fill":"#FF5A7D"}));
}

HundredOneInline.defaultProps = {"width":"212","height":"376","viewBox":"0 0 212 376","fill":"none"};

module.exports = HundredOneInline;

HundredOneInline.default = HundredOneInline;
